import React from 'react'
import { Select } from 'components/UI/Select/Select'
import { Filters } from './constants'

interface UnifiedSearchFiltersProps {
  filters: Filters
  setFilters: React.Dispatch<React.SetStateAction<Filters>>
  sortBy: string
  setSortBy: (sort: string) => void
  categoryOptions: { label: string; value: string }[]
  typeOptions: { label: string; value: string }[]
  sortOptions: { label: string; value: string }[]
  isOppLoading: boolean
}

export function UnifiedSearchFilters({
  filters,
  setFilters,
  sortBy,
  setSortBy,
  categoryOptions,
  typeOptions,
  sortOptions,
  isOppLoading,
}: UnifiedSearchFiltersProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        {/* Opp Cat Filter */}
        <div className="flex items-center space-x-2">
          <Select
            disabled={isOppLoading}
            items={categoryOptions}
            selected={filters.category}
            onSelect={(value) =>
              setFilters((prev) => ({
                ...prev,
                category: value,
                type: 'all', // Reset type when category changes
              }))
            }
            buttonLabel="Opp Cat"
            buttonSize="md"
            buttonVariant="outline"
            className="w-56 min-w-[14rem]"
          />
        </div>

        {/* Opp Type Filter */}
        <div className="flex items-center space-x-2">
          <Select
            disabled={isOppLoading}
            items={typeOptions}
            selected={filters.type}
            onSelect={(value) =>
              setFilters((prev) => ({ ...prev, type: value }))
            }
            buttonLabel="Opp Type"
            buttonSize="md"
            buttonVariant="outline"
            className="w-56 min-w-[14rem]"
          />
        </div>
      </div>

      {/* Sort */}
      <div className="flex items-center space-x-2">
        <Select
          items={sortOptions}
          selected={sortBy}
          onSelect={(value) => setSortBy(value)}
          buttonLabel="Sort"
          buttonSize="md"
          buttonVariant="outline"
          className="w-56 min-w-[14rem]"
        />
      </div>
    </div>
  )
}
